<template>
  <BaseModal
    :title="_T('@Survey modal title')"
    :modal-width="1076"
    @on-close-modal="onCloseModal"
  >
    <Survey
      v-if="getExtra(surveyModal).surveyId"
      :survey-id="getExtra(surveyModal).surveyId"
    />
  </BaseModal>
</template>

<script setup>
import BaseModal from "~/modules/shared/modals/BaseModal.vue";
import Survey from "~/nuxt_modules/survey/ui/components/Survey.vue";
import {
  surveyModal,
  useModalStore,
} from "~/modules/shared/modals/store/modalStore";

const modalStore = useModalStore();
const { getExtra } = storeToRefs(modalStore);

const onCloseModal = () => {
  modalStore.toggleModal(surveyModal);
};
</script>
